<template>
	<!-- Non-zero :'day' values are valid within current month -->
	<b-container :class="day === 0 ? 'placeholderDay' : today ? 'today' : isAdmin ? 'day' : pastDate ? 'pastDate' : undefined" fluid>
		<div id="header" class="m-1" v-if="day !== 0">
			<h5>{{ day }}</h5>
			<b-button 
				id='selectDayBtn' 
				v-if="isAdmin && dateSelectionMode"
				@click="toggleDateSelection()"
			>
				<b-icon 
					icon='plus-square-fill' 
					:variant="dateSelected ? 'success' : 'secondary'" 
					scale="1.25"
				></b-icon>
			</b-button>
		</div>
		<hr class="m-1" />
		<div v-if="status === 'loading'" class="text-center">
			<b-spinner label="loading"></b-spinner>
		</div>

		<div v-else-if="status === 'error'" class="text-center">
			<b-icon icon="exclamation-circle" variant="danger" font-scale="2" ></b-icon>
		</div>

		<div
			id="body"
			v-else-if="isAdmin && status === 'fetched' && classes.length > 0"
		>
			<ClassAdmin
				v-for="(c, index) in classes"
				:key="index"
				:classID="c.classID"
			/>
		</div>

		<div
			id="body"
			v-else-if="!isAdmin && status === 'fetched' && classes.length > 0"
		>
			<Class
				v-for="(c, index) in classes"
				:key="index"
				:classID="c.classID"
				:lateCx="lateCx"
			/>
		</div>
		<div v-else-if="status === 'fetched' && classes.length === 0">
			<span class="text-center d-block m-1">No classes :(</span>
		</div>
	</b-container>
</template>

<script>
import EventBus from '@/eventBus'
import Class from "@/components/MedEx/Class.vue"
import ClassAdmin from "@/components/MedEx/ClassAdmin.vue"

export default {
	name: "Day",
	props: {
		year: {
			type: Number,
			required: false,
		},
		month: {
			type: Number,
			required: false,
		},
		day: {
			type: Number,
			required: true,
		},
	},
	components: {
		Class,
		ClassAdmin,
	},
	data() {
		return {
			status: "loading",
			classes: [],
		}
	},
	computed: {
		dateString() {
			if (this.day != 0) {
				return new Date(this.year, this.month, this.day, 0, 0, 0)
					.toISOString()
					.substr(0, 10)
			} else {
				return null
			}
		},
		isAdmin() {
			return this.$store.getters.isAdmin
		},
		dateSelectionMode() {
			return this.$store.state.dateSelectionMode
		},
		dateSelected() {
			return this.$store.getters.dateSelection.includes(this.dateString)
		},
		pastDate() {
			return new Date(this.dateString + ' 00:00:00') < new Date().setHours(0,0,0,0)
		},
		today() {
			return this.dateString === new Date().toISOString().substr(0, 10)
		},
		lateCx() {
			return new Date() > new Date(this.year, this.month, this.day-1, 16, 0, 0) ? true : false
		}
	},
	methods: {
		getClassesOnDay: function() {
			return new Promise((resolve, reject) => {
				this.classes = []
				fetch(this.$apiURL + "/getClassesOnDay", {
					method: "POST",
					body: JSON.stringify({
						date: this.dateString,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(classes => {
							this.classes = classes
							resolve()
						})
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {

						reject(res)
					}
				})
			})
		},
		updateDay: function() {
			this.status = "loading"
			return new Promise((resolve, reject) => {
				this.classes = []
				fetch(this.$apiURL + "/getClassesOnDay", {
					method: "POST",
					body: JSON.stringify({
						date: this.dateString,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(classes => {
							if (this.classes != classes) {
								this.classes = classes
							}
							this.status = "fetched"
							resolve()
						})
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {
						this.status = 'error'
						reject(res)
					}
				})
			})
		},
		toggleDateSelection: function () {
			return new Promise (resolve => {
				if (this.dateSelected) {
					this.$store.dispatch('removeDateSelection', this.dateString)
						.then(() => {
							resolve()
						})
				}
				else {
					this.$store.dispatch('appendDateSelection', this.dateString)
						.then(() => {
							resolve()
						})
				}
			})
		}
	},
	created() {
		if (this.day != 0) {
			this.getClassesOnDay().then(() => {
				this.status = "fetched"
			})
		}
	},
	watch: {
		month: function() {
			this.status = "loading"
			if (this.day != 0) {
				this.getClassesOnDay().then(() => {
					this.status = "fetched"
				})
			}
		},
	},
	mounted() {
		EventBus.$on('refreshDays', async () => {
			await this.updateDay()
		})
	}
}
</script>

<style scoped>
.day {
	margin: 0px auto 15px auto;
	min-height: 30px;
	min-width: 200px;
}

.placeholderDay {
	visibility: hidden;
	margin: 10px auto;
	padding: 15px;
	min-height: 30px;
}

.pastDate {
	opacity: 0.6;
	pointer-events: none;
}

.today {
	border: 2px solid #00cc00;
	border-radius: 25px;
}

#header h5 {
	display: inline-block;
	padding-left: 5px;
}

#selectDayBtn {
	display: block;
	background-color: transparent;
	border: none;
	float: right;
}

#selectDayBtn:focus, #selectDayBtn:active {
	outline: none;
	box-shadow: none;
}

.b-icon-animation-cylon {
	display: block;
	margin: 0 auto;
}

@media screen and (max-width: 992px) {
	.placeholderDay {
		display: none;
	}
}
</style>
